import React, { useEffect } from 'react';
import './index.scss';
import { GetMobileStyledCompImg, GetStyledCompImg } from 'common-modules/general/Modules/functions';
import { ResponseWatchlist, YnAgreeModel } from 'common-modules/general/API/watchlist/types';
import { RoutesString } from 'common-modules/general/Modules/routesString';

import RadioBox from './RadioBox';
import CheckBox from './CheckBox';
import MobxStore from 'common-modules/general/Store/MobxStore';


interface IInterestPopup {
  isOpen: boolean;
  setIsOpenInterestPopup: React.Dispatch<React.SetStateAction<boolean>>;
  dataCheck: ResponseWatchlist[];
  setDataCheck: React.Dispatch<React.SetStateAction<ResponseWatchlist[] | null>>;
  onClickConfirmButton(): void;
  onClickCloseButton(): void;
  agree: YnAgreeModel;
  setAgree: React.Dispatch<React.SetStateAction<YnAgreeModel | null>>;
}

const handlerInfoplen = (infoPlen: string) => {
  return infoPlen.replace('㎡', '');
};

const InterestPopup = ({
  isOpen,
  setIsOpenInterestPopup,
  dataCheck,
  setDataCheck,
  onClickConfirmButton,
  onClickCloseButton,
  agree
}: IInterestPopup) => {
  const { toaster } = MobxStore();
  const [step, setStep] = React.useState(0);    // 1: 마케팅동의, 2: 관심평형선택
  const [ynPbrlAgrt, setYnPbrlAgrt] = React.useState<null | boolean>(null);    // 마케팅 개인정보 수집 동의 여부
  const [ynSmsRcpn, setYnSmsRcpn] = React.useState<boolean>(false);
  const [ynEmailRcpn, setYnEmailRcpn] = React.useState<boolean>(false);

  useEffect(() => {
    initPbrlAgrt();

    const body = document.getElementsByTagName('body');
    const header = document.getElementById('sticky-root-main-nav');

    if (isOpen) {
      body[0].classList.add('burgerMenu-open');

      if (header) {
        header.style.zIndex = '90';
      }
    } else {
      body[0].classList.remove('burgerMenu-open');

      if (header) {
        header.style.zIndex = '180';
      }
    }
  }, [isOpen]);

  const initPbrlAgrt = () => {
    setStep(agree.agreeCheck ? 2 : 1);
    setYnPbrlAgrt(null);
    setYnSmsRcpn(false);
    setYnEmailRcpn(false);
  }

  const changePbrlAgrt = (ynPbrlAgrt) => {
    setYnPbrlAgrt(ynPbrlAgrt);
    setYnSmsRcpn(ynPbrlAgrt);
    setYnEmailRcpn(ynPbrlAgrt);
  }

  const handleClickNextButton = () => {
    if (!agree.agreeCheck) {
      if (!ynPbrlAgrt) {
        toaster.toast('마케팅 목적 활용을 위한 개인정보 수집·이용 동의 여부를 선택해 주시기 바랍니다.');
      } else if (ynPbrlAgrt && (!ynSmsRcpn && !ynEmailRcpn)) {
        toaster.toast('마케팅정보 제공을 위한 개인정보 수집·이용 동의 시 수신방법을 선택해 주시기 바랍니다.');
      } else {
        agree.ynSmsRcpn = ynSmsRcpn;
        agree.ynEmailRcpn = ynEmailRcpn;
        setStep(2);
      }
    }
  };

  return isOpen ? (
    <div className="Interest-popup-checkbox">
      <div className="popup-wrap">
        <div className="popup-header">
          <h3>관심 평형 선택</h3>
          <div className='btn-box'>
            <a
              className='close-btn'
              onClick={() => {
                onClickCloseButton();
                setIsOpenInterestPopup(false);
              }}
            >
              <img
                src={GetMobileStyledCompImg('common/ico_close_layerpopup01.png')}
                alt="닫기"
              />
            </a>
          </div>
        </div>

        {/* 마케팅 동의 화면*/}
        {step == 1 && (
          <div className='popup-content' style={{ display: 'block' }}>
            <div className='popup-body'>
              <div className='popup-info'>
                <i className='ico-info-point'></i>
                <p>마케팅 목적에 따른 개인정보 수집·이용 동의서에 동의하지 않으실 경우,<br/>관심고객 등록 및 분양정보 안내가 불가합니다.</p>
              </div>

              <div className='popup-agree mt-30'>
                <div className="agree-title">
                  {/* <span>(선택)</span> */}
                  <p>마케팅 목적에 따른 개인정보 수집 이용 동의서</p>
                </div>
                <div className="scrollbar-outer mt-15">
                  <div className="scrollbar-inner">
                    <div className="agreement-container">
                      <div className="part">
                        <p className="list">
                          아래의 개인정보 수집∙이용에 대한 내용을 자세히 읽어 보신 후 동의 여부를 결정하여 주시기 바랍니다.
                        </p>
                        <p className="chapter-tit">개인정보 수집∙이용 내용</p>
                        <div className="table-container type01">
                          <table className="table-col">
                            <caption>구분 : 수집·이용 목적, 수집·이용 항목 ,보유·이용 기간</caption>
                            <colgroup>
                              <col width="35%" />
                              <col width="65%" />
                            </colgroup>
                            <tbody>
                              <tr>
                                <th>수집·이용 목적</th>
                                <td className="h-align-l">
                                  <p className="strong-sub">
                                    DL건설㈜의 분양(임대, 상가 포함)정보 제공, 제휴행사 및 서비스 홍보를 위한 마케팅 자료 활용, 서비스 및
                                    이벤트 정보 제공
                                    <br />※ 정보 제공을 위해 전자적 전송매체를 이용하여 고객님께 연락할 수 있습니다.
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <th>수집·이용 항목</th>
                                <td className="h-align-l">
                                  <p className="chapter-sub">필수항목</p>
                                  <p>
                                    이름, 성별, 생년월일, 휴대전화번호, 이메일, 주소, 관심 주택형/설문내용(관심고객 등록 시)
                                  </p>
                                  <p className="chapter-sub">선택항목</p>
                                  <p>없음</p>
                                </td>
                              </tr>
                              <tr>
                                <th>보유·이용 기간</th>
                                <td className="h-align-l">
                                  <p className="strong-sub">개인정보 변경에서 마케팅 동의 철회 혹은 회원탈퇴시 까지</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <p className="chapter-tit mt-60">개인정보 처리업무 위탁</p>
                        <div className="table-container type01">
                          <table className="table-col">
                            <caption>구분 : 업무내용, 취급을 위탁 받는자(수탁업체)</caption>
                            <colgroup>
                              <col width="50%" />
                              <col width="50%" />
                            </colgroup>
                            <thead>
                              <tr>
                                <th>업무내용</th>
                                <th>취급을 위탁 받는자(수탁업체)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <p className="list">분양 및 마케팅 업무 대행(분양정보발송, 상담, 고객 불만 접수 처리 등)</p>
                                </td>
                                <td>
                                  <p className="list">삼일산업(주) 등 46개 업체</p>
                                  <p className="list">
                                    <a className="link" href={`${RoutesString.Person}#terms6`}>
                                      전체 개인정보 처리업무 수탁업체 보기
                                      <i className="ico-next-arrow-small-grey" aria-hidden="true"></i>
                                    </a>
                                  </p>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <p className="list">고객정보 시스템 운영</p>
                                </td>
                                <td>
                                  <p className="list">㈜대림</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <p className="list mt-10">
                          ※ 상기 업무 위탁의 내용이 변경될 경우, 회사는 변경된 내용을 서면의 방법을 통해 고지할 예정입니다.
                        </p>
                        <p className="list">
                          다만, 정보주체의 연락처 불명 등 위 사실의 고지가 불가능한 경우에는 관련 법령에 의거하여 당사 홈페이지 혹은
                          사업장에 게시된 개인정보처리방침을 통해 변경 내용을 공개합니다.
                        </p>

                        <p className="chapter-sub">동의 거부권 및 동의거부에 따른 불이익</p>
                        <p className="list">
                          고객님은 위와 같이 개인정보를 수집∙이용하는데 동의를 거부할 권리가 있습니다. 다만, 동의를 거부하는 경우 정보
                          제공 서비스가 불가합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="agreement-box mt-20">
                  <div className="choice-box">
                    <p className="txt-desc-small02">위와 같은 마케팅 목적 활용을 위한 개인정보 수집∙이용에 동의하십니까?</p>
                    <div className="radio-area">
                      <div className="radio01">
                        <RadioBox
                          labelPos="right"
                          checked={Boolean(ynPbrlAgrt)}
                          fn={() => changePbrlAgrt(true)}
                          id="first1"
                          name="first"
                          label="동의"
                          value="01"
                        />
                      </div>
                      <div className="radio01">
                        <RadioBox
                          labelPos="right"
                          checked={ynPbrlAgrt === false}
                          fn={() => changePbrlAgrt(false)}
                          id="first2"
                          name="first"
                          label="미동의"
                          value="02"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div id="pbrl-agrt" className="agreement-box-type02 mt-20 ui-agree"> {/* display-n 클래스 추가 시 display none 처리 됨 */}
                  <div className="column-group float ">
                    <div className="column col-2">
                      <div className="txt-desc-small02">분양정보 수신방법 선택</div>
                    </div>
                    <div className="radio-box">
                      <span className="input-checkbox right mr-30">
                        <CheckBox
                          checked={Boolean(ynSmsRcpn)}
                          fn={() => setYnSmsRcpn(!ynSmsRcpn)}
                          labelPos="right"
                          label="SMS(문자)"
                          id="chkBox01"
                        // disabled={!ynPbrlAgrt}
                        />
                      </span>
                      <span className="input-checkbox right mr-30">
                        <CheckBox
                          checked={Boolean(ynEmailRcpn)}
                          fn={() => setYnEmailRcpn(!ynEmailRcpn)}
                          labelPos="right"
                          label="메일"
                          id="chkBox02"
                        // disabled={!ynPbrlAgrt}
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='popup-footer'>
              {/* <div
                className="no"
                onClick={() => {
                  onClickCloseButton();
                  setIsOpenInterestPopup(false);
                }}>
                <span>취소</span>
              </div> */}
              <div
                className="ok ml-20"
                onClick={() => {
                  handleClickNextButton();
                }}>
                <span>확인 후 평형선택</span>
              </div>
            </div>
          </div>
        )}

        {/* 관심 평형 선택 화면*/}
        {step == 2 && (
          <div className='popup-content' >
            <div className="popup-body">
              <div className="interest-popup-container">
                <ul className="list-checkbox">
                  {dataCheck.length > 0 ? (
                    dataCheck.map((item, index) => {
                      return (
                        <li key={`${item.infoPlen}${item.infoPlenType}-${item.selected}`} className="list-checkbox-item">
                          <input defaultChecked={item?.selected === 'Y'} type="checkbox" id={`item-checkbox-${index}`} />
                          <label
                            htmlFor={`item-checkbox-${index}`}
                            onClick={e => {
                              const result: Array<ResponseWatchlist> = dataCheck.map(innerData => {
                                if (innerData.infoPlen === item.infoPlen && innerData.infoPlenType === item.infoPlenType) {
                                  return {
                                    ...item,
                                    selected: item.selected === 'Y' ? 'N' : 'Y'
                                  };
                                } else {
                                  return innerData;
                                }
                              });

                              setDataCheck(result);
                            }}>
                            <span>
                              {handlerInfoplen(item.infoPlen)}
                              {item.infoPlenType === 'Z' ? '' : item.infoPlenType}㎡
                            </span>
                          </label>
                        </li>
                      );
                    })
                  ) : (
                    <li className='no-data'>평면 정보가 없습니다.</li>
                  )}
                </ul>
              </div>

              <div className="text">
                <p>※ 선택하신 평형에 대한 분양 및 관련 정보는 고객님이 수신 동의하신 매체(문자 또는 이메일)로 안내됩니다. 단, 추후 마케팅 정보 수신 동의를 ‘미동의’로 변경한 고객님께는 안내가 불가합니다.</p>
              </div>
            </div>

            {/* 기존 마케팅 동의 고객용 버튼 */}
            {agree.agreeCheck && (
              <div className="popup-footer">
                <div
                  className="ok"
                  onClick={() => {
                    onClickConfirmButton();
                  }}>
                  <span>확인</span>
                </div>
              </div>)}
            {/* 마케팅 동의 팝업에서 넘어 온 고객용 버튼 */}
            {!agree.agreeCheck && (
              <div className="popup-footer">
                <div
                  className="no"
                  onClick={() => {
                    setStep(1);
                  }}>
                  <span>이전</span>
                </div>
                <div
                  className="ok ml-20"
                  onClick={() => {
                    onClickConfirmButton();
                  }}>
                  <span>선택 완료</span>
                </div>
              </div>
            )}
          </div>
        )}

        {step == 0 && (
          <div></div>
        )}
      </div>
    </div>


  ) : (
    <div />
  );
};

export default InterestPopup;
